module.exports = __webpack_public_path__ + "img/failure-loading.884a36b6.svg";